<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <div
      v-if="user.type_id == 1"
      class="layout-sidebar"
      @click="onSidebarClick"
    >
      <AppMenu :model="menuSup" @menuitem-click="onMenuItemClick" />
    </div>

    <div
      v-else-if="user.type_id == 3"
      class="layout-sidebar"
      @click="onSidebarClick"
    >
      <AppMenu :model="menuMoov" @menuitem-click="onMenuItemClick" />
    </div>

    <div v-else class="layout-sidebar" @click="onSidebarClick">
      <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
    </div>

    <div class="layout-main-container">
      <div class="layout-main">
        <router-view />
      </div>
      <AppFooter />
    </div>

    <!-- BOUTTON PARAMETRE QUI CHANGE LE STYLE DE LA PAGE AUTOMATIQUEMENT -->
    <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
    <transition name="layout-mask">
      <div
        class="layout-mask p-component-overlay"
        v-if="mobileMenuActive"
      ></div>
    </transition>
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppMenu from "./AppMenu.vue";

/* <!-- BOUTTON PARAMETRE QUI CHANGE LE STYLE DE LA PAGE AUTOMATIQUEMENT --> */
import AppConfig from "./AppConfig.vue";
import AppFooter from "./AppFooter.vue";

export default {
  emits: ["change-theme"],
  data() {
    return {
      layoutMode: "static",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      user: JSON.parse(localStorage.getItem("user")),
      menuSup: [
        {
          label: "Home",
          items: [
            {
              label: "Dashboard",
              icon: "pi pi-fw pi-home",
              to: "/",
            },
          ],
        },

        {
          label: "Produits",
          items: [
            {
              label: "Liste des produits",
              icon: "pi pi-fw pi-list",
              to: "/products",
            },
          ],
        },

        //   {
        //   label: "Groupe Wathsapp",
        //   items: [
        //     {
        //       label: "Liste des numeéro",
        //       icon: "pi pi-fw pi-list",
        //       to: "/emodji",
        //     },
        //   ],
        // },

        {
          label: "Messagerie",
          icon: "pi pi-fw pi-sitemap",
          items: [
            {
              label: "Synthèse message",
              icon: "pi pi-fw pi-comment",
              to: "/comptemessage",
            },
            // { label: "Reporting", icon: "pi pi-fw pi-book", to: "/reporting" },
            { label: "Supervision", icon: "pi pi-fw pi-user", to: "/agentcon" },
            {
              label: "Transfert message",
              icon: "pi pi-fw pi-share-alt",
              to: "/emodji",
            },
            // {
            //   label: "Deliveries",
            //   icon: "pi pi-fw pi-clone",
            //   to: "/delivery",
            // },
            /*{label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input'},
                        {label: "Float Label", icon: "pi pi-fw pi-bookmark", to: "/floatlabel"},
                        {label: "Invalid State", icon: "pi pi-fw pi-exclamation-circle", to: "/invalidstate"},
						{label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/button'},
						{label: 'Table', icon: 'pi pi-fw pi-table', to: '/table'},
						{label: 'List', icon: 'pi pi-fw pi-list', to: '/list'},
						{label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/tree'},
						{label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/panel'},
						{label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/overlay'},
                        {label: "Media", icon: "pi pi-fw pi-image", to: "/media"},
						{label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu'},
						
						{label: 'File', icon: 'pi pi-fw pi-file', to: '/file'},
						{label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
						{label: 'Misc', icon: 'pi pi-fw pi-circle-off', to: '/misc'},*/
          ],
        },
      ],
      menu: [
        {
          label: "Home",
          items: [
            {
              label: "Dashboard",
              icon: "pi pi-fw pi-home",
              to: "/",
            },
          ],
        },
        {
          label: "Produits",
          items: [
            {
              label: "Liste des produits",
              icon: "pi pi-fw pi-list",
              to: "/products",
            },
          ],
        },

        // {
        //   label: "Groupe Wathsapp",
        //   items: [
        //     {
        //       label: "Liste des numeéro",
        //       icon: "pi pi-fw pi-list",
        //       to: "/emodji",
        //     },
        //   ],
        // },

        {
          label: "Messagerie",
          icon: "pi pi-fw pi-sitemap",
          items: [
            {
              label: "Synthèse message",
              icon: "pi pi-fw pi-comment",
              to: "/comptemessage",
            },
            { label: "Supervision", icon: "pi pi-fw pi-user", to: "/agentcon" },
            {
              label: "Transfert message",
              icon: "pi pi-fw pi-share-alt",
              to: "/emodji",
            },

            // {
            //   label: "Deliveries",
            //   icon: "pi pi-fw pi-clone",
            //   to: "/delivery",
            // },

            // {
            //   label: "Items",
            //   icon: "pi pi-fw pi-bookmark",
            //   to: "/items",
            // },

            // { label: "Profile", icon: "pi pi-fw pi-user", to: "/profile" },

            /*{label: 'Form Layout', icon: 'pi pi-fw pi-id-card', to: '/formlayout'},
						{label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input'},
                        {label: "Float Label", icon: "pi pi-fw pi-bookmark", to: "/floatlabel"},
                        {label: "Invalid State", icon: "pi pi-fw pi-exclamation-circle", to: "/invalidstate"},
						{label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/button'},
						{label: 'Table', icon: 'pi pi-fw pi-table', to: '/table'},
						{label: 'List', icon: 'pi pi-fw pi-list', to: '/list'},
						{label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/tree'},
						{label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/panel'},
						{label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/overlay'},
                        {label: "Media", icon: "pi pi-fw pi-image", to: "/media"},
						{label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu'},
						
						{label: 'File', icon: 'pi pi-fw pi-file', to: '/file'},
						{label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
						{label: 'Misc', icon: 'pi pi-fw pi-circle-off', to: '/misc'},*/
          ],
        },
      ],
      menuMoov: [
        {
          label: "Home",
          items: [
            {
              label: "Dashboard",
              icon: "pi pi-fw pi-home",
              to: "/",
            },
          ],
        },
        {
          label: "Messagerie",
          icon: "pi pi-fw pi-sitemap",
          items: [
            { label: "Reporting", icon: "pi pi-fw pi-book", to: "/reporting" },
            { label: "Profile", icon: "pi pi-fw pi-user", to: "/profile" },
          ],
        },
      ],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  methods: {
    test() {
      alert(1);
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
      }

      return true;
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
        },
      ];
    },
    logo() {
      return this.$appState.darkTheme
        ? "images/logo-white.svg"
        : "images/logo.svg";
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
    /* <!-- BOUTTON PARAMETRE QUI CHANGE LE STYLE DE LA PAGE AUTOMATIQUEMENT --> */
    AppConfig: AppConfig,
    AppFooter: AppFooter,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
